<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.dashboard_settings.widgets')"
            :is-required="true"
            :error="errors.widgets"
            :hint="__('settings.dashboard_settings.widget_help_text')"
        >
            <DMultiSelect
                id="status-dropdown"
                :options="widgetOptions"
                selection-type="text"
                @update="updateWidgets"
            />
        </DFormRow>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { computed } from 'vue'

const props = defineProps({
    availableWidgets: {
        type: Array,
        default () {
            return []
        }
    },
    selectedWidgets: {
        type: Array,
        default () {
            return []
        }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const form = useForm({
    widgets: props.selectedWidgets
}
)

const widgetOptions = computed(() => {
    return props.availableWidgets.map((value) => {
        return {
            value: value,
            text: value,
            selected: props.selectedWidgets.includes(value)
        }
    })
})

const emit = defineEmits(['form-submitted'])

function submitForm () {
    emit('form-submitted', form)
}

function updateWidgets (values) {
    form.widgets = values
}
</script>
